module.exports = __webpack_public_path__ + "media/src/application/media/wstartup-e5dbb6366cab6ae3342c855e4f715066.jpg";